import React, { useEffect, useState } from 'react';
import { Flexbox, Section } from "../../../../common/fusion-ui";
import { Link } from "react-router-dom";
import { useTheme } from "../../../../common/ProjectThemeProvider";
import { useToast } from "../../../../common/fusion-ui/provider/ToastProvider";
import { checkNullJson, checkNullStr, getJsonValue, getDefStr, isBoolTrue, setTabTitle } from "../../../../common/fusion-ui/utils/ReactUtils";
import { Keys, ModuleRouteUrls, Modules, Selectors } from "../../../config/AppConfig";
import { getAllocatedModuleName, isModuleAllocated, printError, printLog } from "../../../utils/AppUtils";
import { DashSearchView, VokMsgBox } from "../../../index";
import { useConfig } from "../../../context/ConfigProvider";
import useScreenSize from "../../../../common/fusion-ui/hook/useScreenSize";

/**
 * Tab-bar component that contains primary Modules like: Home, Forum, Survey etc.
 *
 * If no tab's needs to be selected, pass: defTab=-1
 */
const DashboardModulesTabPane = React.memo(({
    children,
    wrapperProps = {},
    onSearchClick,
}) => {
    const TAG = "DashboardModulesTabPane";

    const theme = useTheme();
    const { showToast, changeToastVariant } = useToast();
    const { configData, isConfigTrue, getConfig, updateConfig } = useConfig();
    const { isScreenXs, isScreenSm, isScreenUpSm } = useScreenSize();

    const DASH_TAB_CONTENT_WRAPPER_ID = Selectors.DASH_TAB_CONTENT_WRAPPER_ID;
    const DEF_TAB_NAME = Modules.Home;

    const TABS = {
        home: {
            name: Modules.Home,
            renderName: getAllocatedModuleName(Modules.Home),
            url: ModuleRouteUrls[Modules.Home],
            icon: 'bi bi-home',
        },
        webMeeting: isModuleAllocated(Modules.WebMeeting) && {
            name: Modules.WebMeeting,
            renderName: getAllocatedModuleName(Modules.WebMeeting),
            url: ModuleRouteUrls[Modules.WebMeeting],
            icon: 'bi bi-meeting',
        },
        discForum: isModuleAllocated(Modules.DiscussionForum) && {
            name: Modules.DiscussionForum,
            renderName: getAllocatedModuleName(Modules.DiscussionForum),
            url: ModuleRouteUrls[Modules.DiscussionForum],
            icon: 'bi bi-form',
        },
        survey: isModuleAllocated(Modules.Survey) && {
            name: Modules.Survey,
            renderName: getAllocatedModuleName(Modules.Survey),
            url: ModuleRouteUrls[Modules.Survey],
            icon: 'bi bi-survey',
        },
        resources: isModuleAllocated(Modules.Resources) && {
            name: Modules.Resources,
            renderName: getAllocatedModuleName(Modules.Resources),
            url: ModuleRouteUrls[Modules.Resources],
            icon: 'bi bi-resources',
        },
    };

    const Fields = {
        activeTabName: 'activeTabName',
        searchBarInputValue: 'searchBarInputValue',
        isTabSet: 'isTabSet',
    };
    const [fieldsData, setFieldsData] = useState({});

    useEffect(() => {
        // if (!isFieldTrue(Fields.isTabSet)) {
        updateField(Fields.isTabSet, true);
        // const defTab = getConfig(Keys.config_TabBarTab, Modules.Home);
        const defTab = getConfig(Keys.config_TabBarTab);
        // log('useEffect.getConfig.config_TabBarTab:', defTab);
        if (defTab != -1) {
            setTabTitle(getAllocatedModuleName(getDefTab(defTab)));
            if (!checkNullStr(getField(Fields.activeTabName))) {
                updateField(Fields.activeTabName, getDefTab(defTab));
            }
        } else {
            updateField(Fields.activeTabName, null);
        }
    }, [configData]);

    useEffect(() => {

    }, []);

    return (<>
        <Section
            {...wrapperProps}
            className={`m-0 p-0 w-100 dashpane-left-section height85x h-100x xh-auto ${getJsonValue(wrapperProps, 'className')}`}
            id={DASH_TAB_CONTENT_WRAPPER_ID}
            bg={getJsonValue(wrapperProps, 'bg', theme.bg)}
            overflow={'hidden'}
            roundedVariant={5}
            shadowVariant={''}
            style={{
                boxShadow: getJsonValue(wrapperProps, 'boxShadow', theme.boxShadowMdSm),
                minHeight: '92vh',
                ...getJsonValue(wrapperProps, 'style', {}),
            }}
            contentClassName={`h-100`}
            borderless={isBoolTrue(getJsonValue(wrapperProps, 'borderless', true))}
        >
            {/*tab-bar*/}
            {/* Changed by Vandit Tewari (28/10/24) -passed 2 more parameter to flexbox direction, gap done this to split div to next line so inner child of this parent not merge in small screen*/}
            <Flexbox direction={window.innerWidth > 1020 ? 'row' : 'column'} gap={window.innerWidth > 1020 ? '0' : '1vh'} className={'m-0 p-0'} justifyAt={'between'} alignAt={'start'} justifyAtSm={'start'}>
                {/*left - menu-items*/}
                <div className={"dash-modules-nav-bar m-0 p-0 rounded-right-4 xrounded-bottom-right-5 scroller scroller-x-auto none"}
                    style={{ backgroundColor: theme.primaryDark }}>
                    <Flexbox className={'px-3 w-auto pt-1'} justifyAt={'start'} alignAt={'center'}>
                        {Object.values(TABS).map((item, index) => {
                            return checkNullJson(item) && <Link
                                to={item.url}
                                // Update by Vandit Tewari on (6/11/24) - added an consitional rendering for class for the gap b/w items in navigation if in dekstop more space padding in phones less
                                className={`mdl-item cursor-pointer select-none ${window.innerWidth > 500 ? 'px-3' : 'px-2'} pt-1x pb-1 py-0 ls-none rounded-top-4 d-flex jc-center al-center flex-nowrap text-nowrap border-none ${item.name == getField(Fields.activeTabName) ? 'active' : ''}`}
                                key={item.name + index}
                                style={{
                                    height: '34px', // backgroundColor: item.name == getField(Fields.activeTabName) ? theme.bg : theme.primary,
                                }}
                                onClick={(e) => {
                                    if (e.ctrlKey) {
                                        window.open(item.url, '_blank');
                                    } else {
                                        updateField(Fields.activeTabName, item.name);
                                        updateConfig(Keys.config_TabBarTab, item.name);
                                    }

                                    // updateField(Fields.activeTabName, item.name);
                                    // updateConfig(Keys.config_TabBarTab, item.name);
                                }}
                            >
                                <b className={"curve left-curve"}></b>
                                <b className={"curve right-curve"}></b>
                                <span
                                    className={`cursor-pointer x pyx-1 d-flex fd-row flex-nowrap al-center jc-center border-none text-center ${item.name == getField(Fields.activeTabName) ? 'fw-bold' : 'fw-normal'}`}
                                    // Update by Vandit Tewari on (6/11/24) - added an consitional rendering for fontsize in style in phones smaller font size .8 and in other not changed
                                    style={{
                                        color: item.name == getField(Fields.activeTabName) ? theme.primary : theme.textWhite, fontSize: window.innerWidth > 500 ? '' : '.8rem'
                                    }}
                                // iconClass={item.icon}
                                >
                                    {(getDefStr(item.renderName, item.name))}
                                </span>
                                {/*</span>*/}
                            </Link>
                        })}
                    </Flexbox>
                </div>

                {/*right - search-bar*/}
                {/* Changed made by - Vandit on (28/10/24) - Made these changes to fix the top navigator in small screen its text is overlaping so in class name added an new class name DashSearchViewStyle which is declared in fusion_css.css*/}
                {(isConfigTrue(Keys.config_showSearch) && !isScreenUpSm && isModuleAllocated(Modules.Search)) && <div className={'DashSearchViewStyle m-0 p-0 px-2 pe-3 pt-1'}>
                    <DashSearchView
                        onSearchChange={(e, value) => {
                            // updateField(Fields.searchBarInputValue, value);
                        }}
                        onSearchClick={onSearchClick}
                    />
                </div>}
            </Flexbox>

            <div
                className={`m-0 p-1 section app-section borderless shadow-none w-100 h-100 bg-infox position-relative ${getJsonValue(wrapperProps, 'contentClassName')}`}
                style={{}}>
                {canShowMsgBox() && <VokMsgBox />}
                {children}
            </div>
        </Section>
    </>)
    //======================UI Functions start=====================
    //======================UI Functions end=====================

    //======================Util Functions start=====================
    function getDefTab(defTab) {
        try {
            const tabKeys = Object.keys(TABS);
            for (let i = 0; i < tabKeys.length; i++) {
                const tabKey = tabKeys[i];
                if (checkNullJson(TABS[tabKey]) && TABS[tabKey].name == defTab) {
                    return TABS[tabKey].name;
                }
            }
        } catch (error) {
            logErr('getDefTabName:', error);
        }
        return DEF_TAB_NAME;
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({ ...prevState, [field]: value }));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function canShowMsgBox() {
        const url = (window.location.href + '');
        return (url.endsWith(ModuleRouteUrls[Modules.Home])
            || url.endsWith(ModuleRouteUrls[Modules.Publication])
            || url.endsWith(ModuleRouteUrls[Modules.RecentResources])
            || url.endsWith(ModuleRouteUrls[Modules.Documents])
            || url.endsWith(ModuleRouteUrls[Modules.CaseStudy])
            || url.endsWith(ModuleRouteUrls[Modules.Videos])
            || url.endsWith(ModuleRouteUrls[Modules.Images])
            || url.endsWith(ModuleRouteUrls[Modules.UsefulLinks])
        );
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default DashboardModulesTabPane;
